import { render, staticRenderFns } from "./AmountWithheldDetail.vue?vue&type=template&id=7faa41ed&"
import script from "./AmountWithheldDetail.vue?vue&type=script&lang=js&"
export * from "./AmountWithheldDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports